import { render, staticRenderFns } from "./index.vue?vue&type=template&id=352d9d68&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352d9d68')) {
      api.createRecord('352d9d68', component.options)
    } else {
      api.reload('352d9d68', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=352d9d68&", function () {
      api.rerender('352d9d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tcc/index.vue"
export default component.exports